import { compose } from "recompose";
import { connect } from "react-redux";
import {
  firestoreConnect,
  isLoaded,
  isEmpty,
  populate,
} from "react-redux-firebase";
import { getNotificationList } from "./selectors/Notifications.Selector";
import NotificationsIndex from "components/Notifications/NotificationsIndex";

const collection = "notifications";

const populates = [
  { child: "customerId", root: "customers", keyProp: "id" },
  { child: "regionId", root: "regions", keyProp: "id" },
  { child: "equipmentId", root: "equipments", keyProp: "id" },
  { child: "agreementId", root: "agreements", keyProp: "id" },
];

const mapStateToProps = state => {
  const { firestore, firebase } = state;

  const notifications = getNotificationList(state);
  const notificationsV2 = populate(firestore, "notifications", populates);

  const auth = firebase.auth;
  const { error } = state.notifications;

  const isLoading = !isLoaded(notifications);
  const isDataEmpty = isEmpty(notifications);

  return {
    isLoading: isLoading,
    isDataEmpty: isDataEmpty,
    notifications: notifications,
    notificationsV2: notificationsV2,
    auth: auth,
    error: error,
  };
};

export default compose(
  firestoreConnect([
    {
      collection: collection,
      populates: populates,
      orderBy: ["createdAt", "desc"]
    },
    { collection: "customers", },
    { collection: "regions" },
    { collection: "equipments" },
    { collection: "agreements" },
  ]),
  connect(mapStateToProps)
)(NotificationsIndex);
